export const followUpMessages = {
  en: {
    followUps: {
      heading: 'My follow-up reminders',
      fields: {
        titleLabel: 'Title',
        titlePlaceholder: 'What needs following up?',
        descriptionLabel: 'Description (optional)',
        descriptionPlaceholder: 'Add context or next steps',
        dueLabel: 'Due date/time',
        duePlaceholder: 'Select a due date and time',
      },
      actions: {
        create: 'Create reminder',
        creating: 'Creating…',
        complete: 'Complete',
        completing: 'Completing…',
        retry: 'Retry',
      },
      labels: {
        pending: 'Pending',
        dueToday: 'Due Today',
        overdue: 'Overdue',
      },
      accessibility: {
        pendingCount: 'Pending reminder count: {count}',
        completeReminder: 'Complete reminder: {title}',
      },
      states: {
        empty: 'No pending follow-up reminders.',
        loading: 'Loading follow-up reminders…',
        error: 'Follow-up reminders could not be loaded.',
        restricted: 'You can view your reminders, but you cannot create or complete them.',
      },
      notifications: {
        createSuccess: 'Follow-up reminder created.',
        createError: 'The follow-up reminder could not be created.',
        completeSuccess: 'Follow-up reminder completed.',
        completeError: 'The follow-up reminder could not be completed.',
      },
      errors: {
        assignmentRequired: 'You must be actively assigned to this Query to create a follow-up reminder.',
        notFound: 'This Query or follow-up reminder is unavailable or you do not have access to it.',
      },
    },
    myWork: {
      sections: {
        overdue: 'Overdue',
        dueToday: 'Due Today',
        assignedQueries: 'Assigned Query follow-up',
        availabilityProposalWork: 'Availability revisions for Reservations',
        communicationPending: 'Communication Pending',
        openIntake: 'Open Intake',
      },
      empty: {
        overdue: 'No overdue reminders.',
        dueToday: 'No reminders are due today.',
        assignedQueries: 'No assigned Queries need follow-up.',
        availabilityProposalWork: 'No availability revisions are waiting.',
        communicationPending: 'No replies are pending.',
        openIntake: 'No Intake work is waiting.',
      },
      states: {
        loading: 'Loading My Work…',
        error: 'My Work could not be loaded.',
        unavailable: 'Unavailable',
        restricted: 'You do not have access to this work section.',
        retry: 'Retry',
      },
      labels: { revisionRequired: 'Revision required' },
    },
  },
  ja: {
    followUps: {
      heading: '自分のフォローアップリマインダー',
      fields: {
        titleLabel: 'タイトル',
        titlePlaceholder: 'フォローアップする内容を入力',
        descriptionLabel: '説明（任意）',
        descriptionPlaceholder: '背景や次の対応を入力',
        dueLabel: '期限日時',
        duePlaceholder: '期限の日付と時刻を選択',
      },
      actions: {
        create: 'リマインダーを作成',
        creating: '作成中…',
        complete: '完了',
        completing: '完了処理中…',
        retry: '再試行',
      },
      labels: {
        pending: '未完了',
        dueToday: '本日期限',
        overdue: '期限超過',
      },
      accessibility: {
        pendingCount: '未完了のリマインダー数: {count}',
        completeReminder: 'リマインダーを完了: {title}',
      },
      states: {
        empty: '未完了のフォローアップリマインダーはありません。',
        loading: 'フォローアップリマインダーを読み込み中…',
        error: 'フォローアップリマインダーを読み込めませんでした。',
        restricted: 'リマインダーを表示できますが、作成または完了する権限がありません。',
      },
      notifications: {
        createSuccess: 'フォローアップリマインダーを作成しました。',
        createError: 'フォローアップリマインダーを作成できませんでした。',
        completeSuccess: 'フォローアップリマインダーを完了しました。',
        completeError: 'フォローアップリマインダーを完了できませんでした。',
      },
      errors: {
        assignmentRequired: 'フォローアップリマインダーを作成するには、このクエリの有効な担当者である必要があります。',
        notFound: 'このクエリまたはフォローアップリマインダーは利用できないか、アクセス権がありません。',
      },
    },
    myWork: {
      sections: {
        overdue: '期限超過',
        dueToday: '本日期限',
        assignedQueries: '担当クエリのフォローアップ',
        availabilityProposalWork: '予約担当の空き状況改訂',
        communicationPending: '対応待ちコミュニケーション',
        openIntake: '未処理インテーク',
      },
      empty: {
        overdue: '期限超過のリマインダーはありません。',
        dueToday: '本日期限のリマインダーはありません。',
        assignedQueries: 'フォローアップが必要な担当クエリはありません。',
        availabilityProposalWork: '対応待ちの空き状況改訂はありません。',
        communicationPending: '返信待ちのコミュニケーションはありません。',
        openIntake: '対応待ちのインテークはありません。',
      },
      states: {
        loading: 'マイワークを読み込み中…',
        error: 'マイワークを読み込めませんでした。',
        unavailable: '利用できません',
        restricted: 'この作業セクションへのアクセス権がありません。',
        retry: '再試行',
      },
      labels: { revisionRequired: '改訂が必要' },
    },
  },
  'zh-TW': {
    followUps: {
      heading: '我的跟進提醒',
      fields: {
        titleLabel: '標題',
        titlePlaceholder: '需要跟進什麼？',
        descriptionLabel: '說明（選填）',
        descriptionPlaceholder: '新增背景資訊或後續步驟',
        dueLabel: '到期日期／時間',
        duePlaceholder: '選擇到期日期與時間',
      },
      actions: {
        create: '建立提醒',
        creating: '建立中…',
        complete: '完成',
        completing: '完成處理中…',
        retry: '重試',
      },
      labels: {
        pending: '待處理',
        dueToday: '今日到期',
        overdue: '已逾期',
      },
      accessibility: {
        pendingCount: '待處理提醒數量：{count}',
        completeReminder: '完成提醒：{title}',
      },
      states: {
        empty: '沒有待處理的跟進提醒。',
        loading: '正在載入跟進提醒…',
        error: '無法載入跟進提醒。',
        restricted: '您可以查看提醒，但無法建立或完成提醒。',
      },
      notifications: {
        createSuccess: '已建立跟進提醒。',
        createError: '無法建立跟進提醒。',
        completeSuccess: '已完成跟進提醒。',
        completeError: '無法完成跟進提醒。',
      },
      errors: {
        assignmentRequired: '您必須是此查詢目前的有效負責人，才能建立跟進提醒。',
        notFound: '此查詢或跟進提醒無法使用，或您沒有存取權限。',
      },
    },
    myWork: {
      sections: {
        overdue: '已逾期',
        dueToday: '今日到期',
        assignedQueries: '已指派查詢跟進',
        availabilityProposalWork: '預訂團隊可用性修訂',
        communicationPending: '待處理通訊',
        openIntake: '未結案接洽',
      },
      empty: {
        overdue: '沒有已逾期的提醒。',
        dueToday: '今天沒有到期的提醒。',
        assignedQueries: '沒有需要跟進的已指派查詢。',
        availabilityProposalWork: '沒有等待處理的可用性修訂。',
        communicationPending: '沒有待回覆的通訊。',
        openIntake: '沒有待處理的接洽工作。',
      },
      states: {
        loading: '正在載入我的工作…',
        error: '無法載入我的工作。',
        unavailable: '無法使用',
        restricted: '您沒有此工作區段的存取權限。',
        retry: '重試',
      },
      labels: { revisionRequired: '需要修訂' },
    },
  },
  ko: {
    followUps: {
      heading: '내 후속 조치 알림',
      fields: {
        titleLabel: '제목',
        titlePlaceholder: '어떤 후속 조치가 필요한가요?',
        descriptionLabel: '설명(선택 사항)',
        descriptionPlaceholder: '배경 정보 또는 다음 단계를 입력하세요',
        dueLabel: '마감 날짜/시간',
        duePlaceholder: '마감 날짜와 시간을 선택하세요',
      },
      actions: {
        create: '알림 만들기',
        creating: '만드는 중…',
        complete: '완료',
        completing: '완료 처리 중…',
        retry: '다시 시도',
      },
      labels: {
        pending: '대기 중',
        dueToday: '오늘 마감',
        overdue: '기한 초과',
      },
      accessibility: {
        pendingCount: '대기 중인 알림 수: {count}',
        completeReminder: '알림 완료: {title}',
      },
      states: {
        empty: '대기 중인 후속 조치 알림이 없습니다.',
        loading: '후속 조치 알림을 불러오는 중…',
        error: '후속 조치 알림을 불러올 수 없습니다.',
        restricted: '알림을 볼 수 있지만 만들거나 완료할 권한이 없습니다.',
      },
      notifications: {
        createSuccess: '후속 조치 알림을 만들었습니다.',
        createError: '후속 조치 알림을 만들 수 없습니다.',
        completeSuccess: '후속 조치 알림을 완료했습니다.',
        completeError: '후속 조치 알림을 완료할 수 없습니다.',
      },
      errors: {
        assignmentRequired: '후속 조치 알림을 만들려면 이 쿼리의 활성 담당자여야 합니다.',
        notFound: '이 쿼리 또는 후속 조치 알림을 사용할 수 없거나 접근 권한이 없습니다.',
      },
    },
    myWork: {
      sections: {
        overdue: '기한 초과',
        dueToday: '오늘 마감',
        assignedQueries: '배정된 쿼리 후속 조치',
        availabilityProposalWork: '예약팀 가용성 수정',
        communicationPending: '응답 대기 커뮤니케이션',
        openIntake: '미처리 인테이크',
      },
      empty: {
        overdue: '기한이 지난 알림이 없습니다.',
        dueToday: '오늘 마감인 알림이 없습니다.',
        assignedQueries: '후속 조치가 필요한 배정 쿼리가 없습니다.',
        availabilityProposalWork: '대기 중인 가용성 수정이 없습니다.',
        communicationPending: '응답 대기 중인 커뮤니케이션이 없습니다.',
        openIntake: '대기 중인 인테이크 작업이 없습니다.',
      },
      states: {
        loading: '내 작업을 불러오는 중…',
        error: '내 작업을 불러올 수 없습니다.',
        unavailable: '사용할 수 없음',
        restricted: '이 작업 섹션에 접근할 권한이 없습니다.',
        retry: '다시 시도',
      },
      labels: { revisionRequired: '수정 필요' },
    },
  },
} as const;

export const task11Messages = followUpMessages;
